import React from 'react';
import type { ATContextProviderProps } from './types';
import { ATPageIndexContextProvider, useATPageIndex } from './useATPageIndex';
import { ATPageSizeContextProvider, useATPageSize } from './useATPageSize';

export const ATPageContextProvider: React.FC<ATContextProviderProps> = ({
  children,
}) => {
  return (
    <ATPageIndexContextProvider>
      <ATPageSizeContextProvider>{children}</ATPageSizeContextProvider>
    </ATPageIndexContextProvider>
  );
};

// Re-export hooks for convenience
export { useATPageIndex, useATPageSize };
